import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { query, serviceQueries } from 'elc-service-bus';
import { Config } from '../domain/entities/Config';

export class ConfigRepository {
    private config: Config;

    constructor() {
        this.config = diContainer.get(serviceNames.config);
    }

    public getConfigs = async (configs: string[]) => {
        const config = await query(serviceQueries.GET_CONFIG, configs);

        this.config.updateConfig(config);
    };
}
